import { load } from "@cashfreepayments/cashfree-js";
import useEnvironmentCheck from "hooks/useEnvironmentCheck";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MandateSDK = () => {
  const location = useLocation();

  const { getLocalEnvironment } = useEnvironmentCheck();

  const sessionId = new URLSearchParams(location?.search).get("session_id");

  const initializeSDK = async () => {
    const data = await load({
      mode: getLocalEnvironment ? "sandbox" : "production",
    });
    return data;
  };

  useEffect(() => {
    initializeSDK().then((response) => {
      response.subscriptionsCheckout({ subsSessionId: sessionId });
    });
  }, []);

  return <></>;
};

export default MandateSDK;
